import { useCallback, useEffect } from 'react';

type Direction = 'left' | 'right' | null;

let mouseDown: boolean = false;
let mouseX: number | null = null;

export function useMouseMovement() {
  useEffect(() => {
    function setMousePosition(event: MouseEvent | TouchEvent) {
      if (['mousemove', 'mousedown'].includes(event.type)) {
        mouseX = Math.round((event as MouseEvent).pageX);
      }
      if (['touchmove', 'touchstart'].includes(event.type)) {
        mouseX = Math.round((event as TouchEvent).touches[0].pageX);
      }
    }

    function handleMouseDown(event: MouseEvent | TouchEvent) {
      mouseDown = true;
      setMousePosition(event);
    }
    function handleMouseUp() {
      mouseDown = false;
      mouseX = null;
    }
    function handleMouseMove(event: MouseEvent | TouchEvent) {
      if (!mouseDown) {
        return;
      }
      event.preventDefault();
      setMousePosition(event);
    }

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousemove', handleMouseMove);

    document.addEventListener('touchstart', handleMouseDown);
    document.addEventListener('touchend', handleMouseUp);
    document.addEventListener('touchmove', handleMouseMove);

    return () => {
      mouseX = null;

      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchstart', handleMouseDown);
      document.removeEventListener('touchend', handleMouseUp);
      document.removeEventListener('touchmove', handleMouseMove);
    };
  }, []);

  const getMouseDirection = useCallback((playerPosition): [
    Direction,
    number | null
  ] => {
    const x = Math.round(playerPosition);
    if (mouseX === null || mouseX === x) {
      return [null, mouseX];
    }

    return [mouseX > x ? 'right' : 'left', mouseX];
  }, []);

  return getMouseDirection;
}
